import { faCloudArrowUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

const StyledCircle = styled.div`
width:32px;
height:32px;
background: #D9D9D9;
border: 4px solid #F2F2F2;
border-radius: 28px;
display: flex;
align-items:center;
justify-content:center;
`;
export const UploadCloudIcon = () => (
    <StyledCircle>
        <FontAwesomeIcon icon={faCloudArrowUp} width={20} />
    </StyledCircle>
)
